import { useMemo } from 'react';
import {
  FiBook,
  FiCalendar,
  FiPlusCircle,
  FiPlus,
  FiHome,
  FiUsers,
  FiUserCheck,
} from 'react-icons/fi';
import { isAdmin } from '../utils/roles';

/**
 * Primary app navigation links (sidebar + mobile menu).
 */
export function useAppNavItems(profile) {
  const admin = isAdmin(profile);

  return useMemo(() => {
    const items = [
      { to: '/', label: 'Inicio', icon: FiHome, end: true },
      { to: '/recetas', label: 'Gestión de Recetas', icon: FiBook },
      { to: '/nueva-receta', label: 'Nueva Receta', icon: FiPlusCircle },
    ];

    if (admin) {
      items.push(
        { to: '/meal-plans', label: 'Ver planes', icon: FiCalendar },
        { to: '/create-meal-plan', label: 'Nuevo Plan', icon: FiPlus },
        { to: '/admin/users', label: 'Usuarios', icon: FiUsers },
        { to: '/admin/clients', label: 'Clientes', icon: FiUserCheck }
      );
    } else {
      items.push(
        { to: '/create-meal-plan', label: 'Nuevo Plan', icon: FiPlus },
        { to: '/meal-plans', label: 'Mis planes', icon: FiCalendar }
      );
    }

    return items;
  }, [admin]);
}

export default useAppNavItems;
